import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useAuthParams = () => {
  const nav = useNavigate();

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const email = query.get('email');
    if (email) {
      localStorage.setItem('email', email);
    }

    fetch('/api/permissions')
      .then((response) => (response.ok ? response.json() : null))
      .then((permissions) => {
        if (!permissions) return;
        localStorage.setItem(
          'pw-isFinanceUser',
          String(!!permissions.PE_FINANCE_USERS)
        );
        localStorage.setItem('pw-isDevUser', String(!!permissions.PE_DEV_USERS));
        localStorage.setItem(
          'pw-canDownloadModel',
          String(!!permissions.PE_MODEL_DOWNLOAD_USERS)
        );
        localStorage.setItem(
          'pw-isSiteLeaseUser',
          String(!!permissions.PE_SITE_LEASE_USERS)
        );
      })
      .catch(() => {});
  }, [nav]);
};

export default useAuthParams;